import dayjs from 'dayjs';

export const mapInputIATypeToActualAbsencePeriodType = (
  inputIAType: string,
) => {
  const officeVisitTypes = ['Treatment/Medical Appointment', 'Office Visit'];
  const incapacityTypes = [
    'Incapacity',
    'Episode of Incapacity',
    'Episode',
    'Care Due to Incapacity',
  ];

  if (officeVisitTypes.includes(inputIAType)) {
    return 'Office Visit';
  }

  if (incapacityTypes.includes(inputIAType)) {
    return 'Incapacity';
  }

  return 'Other';
};

const getTimeParts = (value: any) => {
  const parsedDateTime = dayjs(value as string | number | Date);

  if (value instanceof Date || parsedDateTime.isValid()) {
    const d = parsedDateTime;
    return { hour: d.hour(), minute: d.minute() };
  }

  if (typeof value === 'string') {
    const timeValue = value.trim();
    const amPmRegex = /^(\d{1,2}):(\d{2})\s*([AaPp][Mm])$/;
    const amPm = amPmRegex.exec(timeValue);

    if (amPm) {
      const hourPart = Number.parseInt(amPm[1], 10);
      const minutePart = Number.parseInt(amPm[2], 10);
      const suffix = amPm[3].toUpperCase();

      if (
        hourPart >= 1 &&
        hourPart <= 12 &&
        minutePart >= 0 &&
        minutePart <= 59
      ) {
        const normalizedHour =
          suffix === 'PM' ? (hourPart % 12) + 12 : hourPart % 12;

        return { hour: normalizedHour, minute: minutePart };
      }
    }

    const twentyFourHourRegex = /^([01]?\d|2[0-3]):([0-5]\d)$/;
    const twentyFourHour = twentyFourHourRegex.exec(timeValue);

    if (twentyFourHour) {
      return {
        hour: Number.parseInt(twentyFourHour[1], 10),
        minute: Number.parseInt(twentyFourHour[2], 10),
      };
    }
  }

  return null;
};

export const combineDateAndTimeAsLocal = (dateValue: any, timeValue: any) => {
  const date = dayjs(dateValue as string | number | Date);
  const timeParts = getTimeParts(timeValue);

  if (!date.isValid() || !timeParts) {
    return new Date(Number.NaN);
  }

  return date
    .hour(timeParts.hour)
    .minute(timeParts.minute)
    .second(0)
    .millisecond(0)
    .toDate();
};
